import {
  POLICY_ONWER_ANNUITY_DATA_REQUEST,
  POLICY_ONWER_ANNUITY_DATA_SUCCESS,
  POLICY_ONWER_ANNUITY_DATA_FAIL,
} from '../constants/policyOwnerAnnuityConstants';

export const policyOwnerAnnuityReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case POLICY_ONWER_ANNUITY_DATA_REQUEST:
      return { loading: true, formData: [] };
    case POLICY_ONWER_ANNUITY_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case POLICY_ONWER_ANNUITY_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
